{
	"name": "@atlaskit/tooltip",
	"version": "16.0.4",
	"sideEffects": false
}
